import { jsPDF } from "jspdf";
import { renderToStaticMarkup } from "react-dom/server";
import { PlayField } from "@/components/field/PlayField";
import { resolvePlayers } from "@/lib/geometry";
import { ROLE_COLORS, roleOf } from "@/lib/roles";
import { HIT_TEXT, RUNNER_TEXT } from "@/lib/jobs";

const CSS_VARS = { "--grass": "#1f6b25", "--foul": "#174f1b", "--dirt": "#b76e28", "--mound": "#c98340", "--track": "#8d4f18", "--runner": "#ea580c" };

export const fieldSvg = (play, cfg, ball, showLabels = true) => {
  const positions = resolvePlayers(play, ball, cfg);
  const svg = toStaticSvg(
    <PlayField cfg={cfg} runners={play.runners} positions={positions} throws={play.throws} runnerPaths={play.runner_paths}
      hit={{ id: 1, ball, hitType: play.hit_type, foul: false }} playId="pdf" still showLabels={showLabels} />
  );
  return { positions, svg };
};

export const toStaticSvg = (el) => renderToStaticMarkup(el).replace(/var\((--[a-z]+)\)/g, (_, v) => CSS_VARS[v] || "#000");

export const svgToPng = async (svg, w, h) => {
  const img = new Image();
  img.src = `data:image/svg+xml;charset=utf-8,${encodeURIComponent(svg)}`;
  await img.decode();
  const canvas = document.createElement("canvas");
  canvas.width = w;
  canvas.height = h;
  canvas.getContext("2d").drawImage(img, 0, 0, w, h);
  return canvas.toDataURL("image/jpeg", 0.85);
};

const situation = (p) => `${HIT_TEXT[p.hit_type]} to ${p.fielder}  ·  ${p.outs} out${p.outs === 1 ? "" : "s"}  ·  ${RUNNER_TEXT[p.runners]}`;

async function addPage(doc, play, cfg, teamName, ball) {
  const M = 40;
  const W = 612 - M * 2;
  doc.setFont("helvetica", "bold").setFontSize(10).setTextColor(90);
  doc.text(`DIAMONDPLAY  ·  ${teamName.toUpperCase()}  ·  ${cfg.name.toUpperCase()}`, M, M);
  doc.text(play.customized ? "COACH'S VERSION" : "DEFAULT PLAY", 612 - M, M, { align: "right" });
  doc.setFontSize(18).setTextColor(15);
  doc.text(situation(play), M, M + 26);
  doc.setFont("helvetica", "normal").setFontSize(11);
  const expl = doc.splitTextToSize(play.explanation, W);
  doc.text(expl, M, M + 46);
  let y = M + 46 + expl.length * 14 + 6;
  const { svg, positions } = fieldSvg(play, cfg, ball);
  const h = (W * 1.19) / 1.44;
  doc.addImage(await svgToPng(svg, 1440, 1190), "JPEG", M, y, W, h);
  y += h + 22;
  doc.setFont("helvetica", "bold").setFontSize(12).text("ASSIGNMENTS", M, y);
  y += 16;
  const rows = Object.values(positions);
  rows.forEach((p, i) => {
    const cx = M + (i % 3) * (W / 3);
    const cy = y + Math.floor(i / 3) * 20;
    doc.setFillColor(ROLE_COLORS[roleOf(p.job)]).circle(cx + 7, cy - 4, 7, "F");
    doc.setFont("helvetica", "bold").setFontSize(10).setTextColor(15).text(`${p.pos}`, cx + 18, cy);
    doc.setFont("helvetica", "normal").text(p.label, cx + 40, cy);
  });
  y += Math.ceil(rows.length / 3) * 20 + 8;
  const notes = [...play.notes, ...(play.coach_note ? [`Coach: ${play.coach_note}`] : []),
    ...rows.filter((p) => p.note).map((p) => `${p.pos}: ${p.note}`)];
  doc.setFontSize(10);
  notes.forEach((n) => {
    const lines = doc.splitTextToSize(`• ${n}`, W);
    if (y + lines.length * 13 > 760) return;
    doc.text(lines, M, y);
    y += lines.length * 13 + 2;
  });
}

export async function exportPlaysPdf(items, cfg, teamName, filename) {
  const doc = new jsPDF({ unit: "pt", format: "letter" });
  for (let i = 0; i < items.length; i += 1) {
    if (i > 0) doc.addPage();
    await addPage(doc, items[i].play, cfg, teamName, items[i].ball || items[i].play.ball);
  }
  doc.save(filename);
}
